export const SIGNATURE_ANNOTATION = 'signature_annotation';
export const TEXT_ANNOTATION = 'text_annotation';
export const DATE_ANNOTATION = 'date_annotation';
export const FORMS_FEATURE = 'forms';
export const MARKETING_FEATURE = 'marketing';
export const REWARDS_FEATURE = 'rewards';
